import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { BodegaService } from 'src/app/services/bodega.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MovimientoStockService } from 'src/app/services/movimiento-stock.service';
import { ProductoService } from 'src/app/services/producto.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { debounceTime, filter } from 'rxjs/operators';
import * as _ from 'lodash'
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { UtilsService } from "src/app/shared/services/utils.service";

@Component({
  selector: "app-exist-stock-producto",
  templateUrl: "./exist-stock-producto.component.html",
  styleUrls: ["./exist-stock-producto.component.scss"],
  providers: [SecurityService],
})
export class ExistStockProductoComponent implements OnInit {
  // Modales
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private currentPayload: any = null
  optionsBodega: Array<any> = [];
  optionsFormato: Array<any> = [];
  optionsMonth: Array<any> = [];
  optionsYear: Array<any> = [];
  loading: boolean = false
  listaMovimientos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  productoSeleccionado: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private formatoProductoService: FormatoProductosService,
    private clog: ConsoleService,
    private bodegaService: BodegaService,
    private productoService: ProductoService,
    private movimientoStockService: MovimientoStockService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private utilsService: UtilsService,
  ) {
    this.log = this.clog.log('SALDO-SKU-MES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.createForm()
    this.formChangesSubscriptions()
    this.loadBodegas()
  }

  private createForm() {
    const now = this.datesService.CurrentDateToShortTimeString()
    this.formHeader = this.fb.group({
      bodega: [null, [Validators.required]],
      formato: [null, [Validators.required]],
      fecha_movimiento: [now],
      sku: [null, [Validators.required]]
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("sku").valueChanges
      .pipe(filter(Boolean), debounceTime(500))
      .subscribe((codigo: string) => {
        this.modalSeleccionarProducto.searchBySKU(codigo)
      })
  }

  loadBodegas() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({
        value: bodega.codigo,
        label: bodega.nombre,
        sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo
      }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega)
    })
  }

  openModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show()
  }

  onProductoSeleccionado({ data: _productoSeleccionado }) {
    this.productoSeleccionado = _productoSeleccionado
    this.formHeader.get('sku').setValue(_productoSeleccionado.sku)
    this.formHeader.get('formato').setValue(null)

    this.formatoProductoService.GetFormatosByCodigo(
      this.rutEmpresa,
      this.productoSeleccionado.codigo,
      ({ mensajes, respuesta }) => {
        this.log('callback', respuesta.registros)
        this.optionsFormato = respuesta.registros.map(formato => ({ 
          value: formato.formato_codigo, 
          label: `${formato.formato_nombre} - ${formato.formato_codigo}`,
          precio_costo: formato.precio_costo, 
          ...formato 
        }))
        this.formValidatorsService.selectDefaultFormatoProducto(this.formHeader.get('formato'), this.optionsFormato)
      }
    )
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = null

    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_movimiento: this.formHeader.get('fecha_movimiento').value,
        sku: this.formHeader.get('sku').value ? this.formHeader.get('sku').value : '',
        listaBodega: this.formHeader.get('bodega').value,
        listaFormato: this.formHeader.get('formato').value,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.currentPayload = _.cloneDeep(inputParams)

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.movimientoStockService.obtenerStockUnProducto(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaMovimientos = registros
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  exportarExcel() {
    const inputParams = _.cloneDeep(this.currentPayload)
    inputParams.entidad.retornaExcel = true
    delete inputParams.paginaActual
    delete inputParams.cantidadRegistrosPorPagina

    this.log('XLS', JSON.stringify(inputParams))

    this.movimientoStockService.obtenerStockUnProductoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  calcularStockFormatoPrincipal(listado: any) {
    console.log("calcularStockFormatoPrincipal");
    return this.utilsService.calcularStockFormatoPrincipal(listado);
  }
  
  calcularStockFormatoSecundario(listado: any) {
    return this.utilsService.calcularStockFormatoSecundario(listado);
   }
}
